// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2e406cfc84f9ff9e","5052":"780e7a21a99441f1"}[chunkId] + ".css";
};